import React, { FC } from "react";
import { ErrIconSidebar } from "../ErrIconSidebar";
import { UnitObj } from "../../util/quoteCartStorage";
import { styled } from "@mui/material/styles";
import QuoteList from "./QuoteList";

const StyledDivRow = styled("div")({
  display: "flex",
  flexDirection: "row",
});

const StyledDivCol = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
});

interface Props {
  unit: UnitObj;
  checkedPD: boolean;
}

const UnitDetails: FC<Props> = ({ unit, checkedPD }) => {
  const defaultLites = !unit.numberOfLites ? "1 Lite " : "";

  return (
    <StyledDivCol>
      <StyledDivRow>
        {unit.material === "Clad Exterior/Wood Interior"
          ? ` ${defaultLites} Clad/Wood`
          : `${defaultLites} ${unit.material}`}{" "}
        {unit.doorType === "Swing"
          ? unit.swingDirection
          : unit.doorType === "Bi-fold Window"
          ? `Window ${defaultLites ? "BF" : "Bi-Fold"}`
          : unit.doorType === "Bi-fold Zero Corner"
          ? `Corner ${defaultLites ? "BF" : "Bi-Fold"}`
          : unit.doorType === "Bi-fold Door/Window Combo"
          ? `Combo ${defaultLites ? "BF" : "Bi-Fold"}`
          : unit.doorType}
        {unit.required?.length ? <ErrIconSidebar /> : null}
      </StyledDivRow>

      <QuoteList unit={unit} checked={checkedPD} />
    </StyledDivCol>
  );
};

export default UnitDetails;
